import { createReducer, on } from '@ngrx/store';
import * as ThemeActions from './theme.actions';

export type Theme = 'light' | 'dark';

export interface ThemeState {
  theme: Theme;
}

export const initialState: ThemeState = {
  theme: 'light',
};

export const themeReducer = createReducer(
  initialState,
  on(ThemeActions.setTheme, (state, { theme }) => ({ ...state, theme })),
  on(ThemeActions.toggleTheme, (state) => ({
    ...state,
    theme: state.theme === 'light' ? 'dark' : 'light',
  }))
);
